import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";

const GlobalNewsOverviewPage = Scrivito.provideObjClass(
  "GlobalNewsOverviewPage",
  {
    attributes: {
      ...defaultPageAttributes,
      body: [
        "widgetlist",
        {
          only: [
            "HeroSliderWidget",
            "SectionContentWidget",
            "GlobalNewsWidget",
          ],
        },
      ],
      navigationIcon: "string",
      isNavigationPage: ["enum", { values: ["yes", "no"] }],
      ...metadataAttributes,
    },
    extractTextAttributes: ["body", "title", "disturberText", "segmentName"],
  }
);

export default GlobalNewsOverviewPage;
